var map = {
	"./icon_pen_black_off.png": 5553,
	"./icon_pen_black_on.png": 4719,
	"./icon_pen_eraser_off.png": 754,
	"./icon_pen_eraser_on.png": 2462,
	"./icon_pen_highlight_off.png": 6244,
	"./icon_pen_highlight_on.png": 3640,
	"./icon_pen_red_off.png": 593,
	"./icon_pen_red_on.png": 3103
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 870;